import React, { Component } from "react"
import Modal from 'react-modal'
import { Grid, Row, Col, Well } from 'react-bootstrap'
import { connect } from 'react-redux'

import { getSesamThread } from '../redux/dataAnalyticsActions'
import SesamThreadDisplay from './SesamThreadDisplay'


import '../../Modals/Modal.css'

const customStyles = {
    content: {
        position: 'fixed',
        top: '15%',
        left: '12%',
        right: 'auto',
        bottom: 'auto',
        padding: 20,
        zIndex: 9999,
        border: 'none',
        width: '70%',
        height: '80%',
        backgroundColor: 'white',
        border: '1px solid lightgrey'
    }
}

class SesamThreadModal extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentWillMount() {
        this.props.getSesamThread(this.props.threadId)
    }

    render() {
        const { threadId, lock } = this.props

        const thread = this.props.sesamThread

        return (
            <Modal
                ariaHideApp={false}
                isOpen={true}
                onRequestClose={() => this.props.closeModal()}
                style={customStyles}>

                {thread === undefined ? 'Laddar ...' :

                    <Grid fluid>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'right' }}>
                                <span onClick={() => this.props.closeModal()} className="closeButton2">X</span>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <h4>{threadId}</h4>
                                <br />
                                <h5>{lock.custom_name}</h5>
                                <h5>{lock.address?.street}, {lock.address?.zip} {lock.address?.city}</h5>
                            </Col>
                        </Row>

                        <hr />

                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <SesamThreadDisplay thread={thread} lock={lock} />
                            </Col>
                        </Row>
                    </Grid >
                }
            </Modal>
        )

    }
}

const mapState = state => {
    return {
        sesamThread: state.dataAnalytics.sesamThread
    }
}

const mapDispatch = (dispatch) => {
    return {
        getSesamThread: (...args) => dispatch(getSesamThread(...args))
    }
}

export default connect(mapState, mapDispatch)(SesamThreadModal)